<div class="app-not-found">
  <h1>404</h1>
  <p>Página não encontrada.</p>
  <a routerLink="/home">Voltar para o início</a>
</div>
